import { Component, OnInit } from '@angular/core';
import { ApiservicesService } from '../../../apiservices.service';
import { UrlService } from '../../../services/url.service';
import { UserTopComponent } from '../../../components/user-top/user-top.component';
import { EncryptdecryptService } from '../../../services/encryptdecrypt.service';

@Component({
  providers: [UserTopComponent],
  selector: 'app-mitrs',
  templateUrl: './mitrs.component.html',
  styleUrls: ['./mitrs.component.css']
})
export class MitrsComponent implements OnInit {

  //Open Window
  openedWindowStatus: any = null;

  //UI Status Variables
  LoaderStatus: boolean = false;

  //UI List Variables
  AgentList: any;

  //UI Input Variables
  InputAgentIDNo: any = "";

  //Session Variables
  StaffIDNo: any = "";
  StaffIDType: any = "";
  FirmID: any = "";

  //UI View Alert Variables
  AlertType: string = "";
  AlertStatus: boolean = false;
  AlertMessage: string = "";

  constructor(private apiServices: ApiservicesService, private url: UrlService, private top: UserTopComponent, private encryptDecryptService: EncryptdecryptService) { }

  ngOnInit(): void {
    this.FirmID = this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || '');
    this.StaffIDNo = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffIDNo') || '');
    this.StaffIDType = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffIDType') || '');
    this.top.updateTotal();
    this.GetAgent(this.FirmID);
  }

  async GetAgent(FirmID: any) {
    let Params = {
      FirmID: FirmID,
      Role: "0204"
    }
    const result = await this.apiServices.GetFirmStaff(Params);
    this.AgentList = result;
  }

  Submit(TaxAgentIDNo: any) {
    this.LoaderStatus = true;
    if (TaxAgentIDNo == "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila pilih ejen cukai";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      this.GetTicket(TaxAgentIDNo);
      this.LoaderStatus = false;
    }
  }

  async GetTicket(TaxAgentIDNo: any) {
    let Params = {
      "TicketType": 2,
      "IDNo": this.StaffIDNo,
      "IDType": 1,
      "TAFirmID": this.FirmID,
      "IDRole": "",
      "AgentIDNo": TaxAgentIDNo
    }
    const result = await this.apiServices.GetTicket(Params);
    if (result.hasError) {
      this.AlertType = "fail";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      this.Goto(TaxAgentIDNo, result.ticketID);
    }
  }

  async Goto(TaxAgentIDNo: any, TicketID: any) {
    const resultFirmDetails = await this.apiServices.GetFirmDetailByID(Number(this.FirmID));
    var FirmTaxRefNum = await this.EncryptDecryptText('101', resultFirmDetails.noCukaiPendapatanFirma);
    var StaffIDNo = await this.EncryptDecryptText('101', this.StaffIDNo);
    TaxAgentIDNo = await this.EncryptDecryptText('101', TaxAgentIDNo);
    let URL = await this.url.GetURLMITRS() + "?TicketID=" + TicketID + "&JenisFail=" + resultFirmDetails.jenisFile + "&NoCukai=" + FirmTaxRefNum + "&JenisSijil=2&IdNo=" + StaffIDNo + "&IdType=" + this.StaffIDType + "&TAFirmId=" + this.FirmID + "&TAIDNo=" + TaxAgentIDNo;
    this.LoaderStatus = false;
    this.openWindow(URL);
  }
  async EncryptDecryptText(Type: any, Text: any) {
    let EncryptedText;
    const result = await this.apiServices.GetEncryptDecrypt(Type, Text);
    EncryptedText = JSON.parse(JSON.stringify(result));
    return EncryptedText;
  }
  openWindow(URL: any) {
    if (this.openedWindowStatus === null || this.openedWindowStatus.closed)
      this.openedWindowStatus = window.open(URL, "_blank");
    else
      this.openedWindowStatus.focus();
  }
}
